import { Component, Inject, OnInit, ChangeDetectionStrategy, HostListener, PLATFORM_ID } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl, FormControl } from '@angular/forms';
import {Destinations } from '../models/index'
import {HomeService,DataService } from '../services/index'
import { formatDate, isPlatformBrowser } from '@angular/common';
import {Router, NavigationEnd} from "@angular/router"
import { Base64 } from 'js-base64';

import { map, startWith } from 'rxjs/operators';
import { Observable, BehaviorSubject, combineLatest } from 'rxjs';
import { WhitelabelConfigStore } from '../core/config/whitelabel-config.store';
import { PaymentOptionConfig, SlideConfig } from '../core/config/whitelabel-config.model';
import { filterCityOptions } from '../shared/city-search/city-filter';

type HomeCalendarKind = 'oneWay' | 'returnDeparture' | 'returnDate';

interface HomeCalendarDay {
  day: number;
  key: string;
  outside: boolean;
  disabled: boolean;
  selected: boolean;
  today: boolean;
}

const CITY_COUNTRY_FALLBACKS: Record<string, string> = {
  kampala: 'Uganda',
  entebbe: 'Uganda',
  jinja: 'Uganda',
  mbale: 'Uganda',
  tororo: 'Uganda',
  iganga: 'Uganda',
  'fort portal': 'Uganda',
  gulu: 'Uganda',
  hoima: 'Uganda',
  kabale: 'Uganda',
  kasese: 'Uganda',
  lira: 'Uganda',
  lugazi: 'Uganda',
  masaka: 'Uganda',
  mbarara: 'Uganda',
  mukono: 'Uganda',
  soroti: 'Uganda',
  kigali: 'Rwanda',
  arusha: 'Tanzania',
  'dar es salaam': 'Tanzania',
  moshi: 'Tanzania',
  tanga: 'Tanzania'
};

const COUNTRY_CODE_NAMES: Record<string, string> = {
  KE: 'Kenya',
  UG: 'Uganda',
  RW: 'Rwanda',
  TZ: 'Tanzania'
};

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomeComponent implements OnInit {
  bsInlineValue = new Date();
  reactiveForm: UntypedFormGroup;
  returnForm: UntypedFormGroup;
  destinationLoading=false;
  pickup='';
  dropoff='';
  From ="From";
  To ="To";
  traveldate='';
  destinations: Destinations[] = [];
  destination: any = {};
  res: any = {};
  today=new Date();
  bsValue = new Date();
  public pickplaceholder: string = 'Nairobi';
  public destplaceholder: string = 'Kisumu';
  public returnpickplaceholder: string = 'Nairobi';
  public returndestplaceholder: string = 'Mombasa';
  public historyHeading: string = 'Recently selected';
  keyword = 'name';
  returning=false;
  isReadOnly=false;
  //traveldate:any;
  data = [];
  destinationslists=[];
  msg = '';
  formdata={};
  submitted:boolean = false;
  submittedReturn:boolean = false;
  citires:any;
  loading: boolean;
  form = new UntypedFormGroup({
    traveldate: new UntypedFormControl(new Date()),
  });

  //material forms intergration
  myControl = new FormControl();
  testoptions: string[] = ['One', 'Two', 'Three', 'Four', 'Five'];
  filteredOptions: Observable<string[]>;
  filteredDropoffOptions: Observable<string[]>;
  returnfilteredOptions: Observable<string[]>;
  returnfilteredDropoffOptions: Observable<string[]>;
  private optionsSubject: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  private readonly cityCountries = new Map<string, string>();
  options$: Observable<string[]> = this.optionsSubject.asObservable();
  optionsDropoff$: Observable<string[]> = this.optionsSubject.asObservable();
  defaultCities = ["Nairobi", "Mombasa", "Malindi", "Kisumu", "Nakuru", "Busia", "Malaba"];
  canReturn = false;
  readonly minDate = formatDate(new Date(), 'yyyy-MM-dd', 'en-KE');
  readonly calendarWeekdays = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
  calendarOpen: HomeCalendarKind | null = null;
  calendarViewDate = new Date(this.today.getFullYear(), this.today.getMonth(), 1);



  constructor(
    private service : HomeService,
    private dataService : DataService,
    private router:Router,
    private _fb: UntypedFormBuilder,
    @Inject(PLATFORM_ID) private readonly platformId: object,
    private configStore: WhitelabelConfigStore
        ) {
          this.reactiveForm = _fb.group({
            pickup:['', Validators.required],
            dropoff:['', Validators.required],
            traveldate:[this.minDate, Validators.required],
            // returndate:['']
          });

          this.returnForm = _fb.group({
            pickupReturn:['', Validators.required],
            dropoffReturn:['', Validators.required],
            traveldateReturn:[this.minDate, Validators.required],
            returndate:[this.minDate, Validators.required]
          });


       
        
    }
  ngOnInit() {
    this.canReturn = !!this.configStore.snapshot.config?.site.canReturn;
    this.loadDestinations();

    this.filteredOptions = combineLatest([
      this.pickupControl.valueChanges.pipe(startWith('')),
      this.options$
  ]).pipe(
      map(([value, options]) => filterCityOptions(value, options, this.defaultCities))
  );

    this.filteredDropoffOptions = combineLatest([
      this.dropoffControl.valueChanges.pipe(startWith('')),
      this.optionsDropoff$
    ]).pipe(
      map(([value, options]) => filterCityOptions(value, options, this.defaultCities))
    );

    this.returnfilteredOptions = combineLatest([
      this.returnPickupControl.valueChanges.pipe(startWith('')),
      this.options$
    ]).pipe(
      map(([value, options]) => filterCityOptions(value, options, this.defaultCities))
    );

    this.returnfilteredDropoffOptions = combineLatest([
      this.returnDropoffControl.valueChanges.pipe(startWith('')),
      this.options$
    ]).pipe(
      map(([value, options]) => filterCityOptions(value, options, this.defaultCities))
    );


  }

  get config() {
    return this.configStore.snapshot.config;
  }

  get heroImage(): string {
    return this.config?.self.banner || '/assets/images/gallery/mash-poa-1.webp';
  }

  get heroTitle(): string {
    return this.config?.texts.bannerTitle ||
      `Book your next trip with ${this.config?.site.name ?? 'us'}`;
  }

  get heroEyebrow(): string {
    return this.config?.texts.bannerEyebrow || 'Secure, comfortable online booking';
  }

  get heroSubtitle(): string {
    return this.config?.texts.bannerSubtitle ||
      'Search routes, choose your seat and pay securely online.';
  }

  get destinationSlides(): SlideConfig[] {
    if (!this.config?.site.showOtherDestinations) {
      return [];
    }
    return this.config.slides.filter(slide => slide.image && slide.title);
  }

  get acceptedPayments(): PaymentOptionConfig[] {
    const seenBrands = new Set<string>();
    return (this.config?.paymentOptions || []).filter(payment => {
      if (!payment.name || !payment.value) {
        return false;
      }
      const value = payment.value.toLowerCase();
      const brand = value.startsWith('airtel') ? 'airtel' : value;
      if (seenBrands.has(brand)) {
        return false;
      }
      seenBrands.add(brand);
      return true;
    });
  }

  paymentLogo(value: string): string | null {
    const logos: Record<string, string> = {
      mpesa: '/assets/img/company1/mpesa-logo.png',
      mobile: '/assets/img/company1/mpesa-logo.png',
      airtel: '/assets/img/company1/airtrel.jpg',
      mtn: '/assets/img/company1/mtn-logo.jpg',
      niobi_mtn: '/assets/img/company1/mtn-logo.jpg',
      mastercard: '/assets/img/payment-icons/mastercard-straight-64px.png',
      visa: '/assets/img/payment-icons/visa-straight-64px.png'
    };

    const normalized = String(value || '').toLowerCase();
    return normalized.startsWith('airtel') ? logos.airtel : logos[normalized] || null;
  }

  searchTopDestination(destination: SlideConfig): void {
    const route = (destination.description || '')
      .split(/\s*(?:→|->|–|—)\s*/)
      .map(city => city.trim())
      .filter(Boolean);

    if (route.length < 2) {
      this.reactiveForm.patchValue({ dropoff: destination.title || '' });
      document.getElementById('search')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    const [departure, arrival] = route;
    this.returning = false;
    this.reactiveForm.patchValue({
      pickup: departure,
      dropoff: arrival,
      traveldate: this.minDate
    });
    this.clickTopCity(departure, arrival);
  }

  setTripType(returning: boolean): void {
    if (returning && !this.canReturn) {
      return;
    }
    this.returning = returning;
  }

  swapLocations(): void {
    const form = this.returning ? this.returnForm : this.reactiveForm;
    const pickupKey = this.returning ? 'pickupReturn' : 'pickup';
    const dropoffKey = this.returning ? 'dropoffReturn' : 'dropoff';
    const pickup = form.get(pickupKey)?.value;
    const dropoff = form.get(dropoffKey)?.value;
    form.patchValue({ [pickupKey]: dropoff, [dropoffKey]: pickup });
  }

  @HostListener('document:click', ['$event'])
  closeCalendarFromOutside(event: MouseEvent): void {
    if (!(event.target as HTMLElement | null)?.closest('[data-home-calendar]')) {
      this.calendarOpen = null;
    }
  }

  @HostListener('document:keydown.escape')
  closeCalendarFromKeyboard(): void {
    this.calendarOpen = null;
  }

  toggleCalendar(kind: HomeCalendarKind, event: Event): void {
    event.stopPropagation();
    if (this.calendarOpen === kind) {
      this.calendarOpen = null;
      return;
    }

    const selectedDate = this.parseDateKey(this.calendarControlValue(kind));
    this.calendarViewDate = new Date(
      (selectedDate || this.today).getFullYear(),
      (selectedDate || this.today).getMonth(),
      1
    );
    this.calendarOpen = kind;
  }

  moveCalendarMonth(offset: number, event: Event): void {
    event.stopPropagation();
    this.calendarViewDate = new Date(
      this.calendarViewDate.getFullYear(),
      this.calendarViewDate.getMonth() + offset,
      1
    );
  }

  selectCalendarDay(day: HomeCalendarDay, event: Event): void {
    event.stopPropagation();
    if (day.disabled || !this.calendarOpen) {
      return;
    }

    const control = this.calendarControl(this.calendarOpen);
    control?.setValue(day.key);
    control?.markAsDirty();
    control?.markAsTouched();

    if (this.calendarOpen === 'returnDeparture') {
      const returnControl = this.returnForm.get('returndate');
      if ((returnControl?.value || '') < day.key) {
        returnControl?.setValue(day.key);
      }
    }

    this.calendarOpen = null;
  }

  get calendarMonthLabel(): string {
    return new Intl.DateTimeFormat('en-GB', {
      month: 'long',
      year: 'numeric'
    }).format(this.calendarViewDate);
  }

  get calendarDays(): HomeCalendarDay[] {
    const year = this.calendarViewDate.getFullYear();
    const month = this.calendarViewDate.getMonth();
    const leadingDays = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const cellCount = Math.ceil((leadingDays + daysInMonth) / 7) * 7;
    const selectedKey = this.calendarOpen ? this.calendarControlValue(this.calendarOpen) : '';
    const minimumKey = this.calendarOpen === 'returnDate'
      ? this.returnForm.get('traveldateReturn')?.value || this.minDate
      : this.minDate;

    return Array.from({ length: cellCount }, (_, index) => {
      const date = new Date(year, month, index - leadingDays + 1);
      const key = this.dateKey(date);
      const outside = date.getMonth() !== month;
      return {
        day: date.getDate(),
        key,
        outside,
        disabled: outside || key < minimumKey,
        selected: !outside && key === selectedKey,
        today: !outside && key === this.minDate
      };
    });
  }

  formatCalendarValue(value: unknown): string {
    const date = this.parseDateKey(value);
    return date
      ? new Intl.DateTimeFormat('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric'
        }).format(date)
      : 'Select date';
  }

  private calendarControl(kind: HomeCalendarKind) {
    if (kind === 'oneWay') {
      return this.reactiveForm.get('traveldate');
    }
    return this.returnForm.get(kind === 'returnDeparture' ? 'traveldateReturn' : 'returndate');
  }

  private calendarControlValue(kind: HomeCalendarKind): string {
    return this.calendarControl(kind)?.value || '';
  }

  private parseDateKey(value: unknown): Date | null {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return null;
    }
    const [year, month, day] = value.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  private dateKey(date: Date): string {
    return [
      date.getFullYear(),
      String(date.getMonth() + 1).padStart(2, '0'),
      String(date.getDate()).padStart(2, '0')
    ].join('-');
  }

  isSameCity(option: string, value: unknown): boolean {
    return typeof value === 'string' &&
      value.trim().length > 0 &&
      option.localeCompare(value.trim(), undefined, { sensitivity: 'accent' }) === 0;
  }

  cityDescription(city: string): string {
    const details: Record<string, string> = {
      nairobi: 'Capital',
      mombasa: 'Coast',
      malindi: 'Coast',
      kisumu: 'Lakeside',
      nakuru: 'Rift Valley',
      busia: 'Border',
      malaba: 'Border'
    };
    const detail = details[this.cityKey(city)];
    const country = this.cityCountry(city);

    return detail ? `${country} · ${detail}` : country;
  }

  private cityCountry(city: string): string {
    const key = this.cityKey(city);
    const countryFromName = key.match(/(?:,|\s+-\s+)\s*(kenya|uganda|rwanda|tanzania)$/i)?.[1];

    return this.cityCountries.get(key) ||
      CITY_COUNTRY_FALLBACKS[key] ||
      (countryFromName
        ? countryFromName.charAt(0).toUpperCase() + countryFromName.slice(1).toLowerCase()
        : this.config?.site.countryName || 'Kenya');
  }

  private cityKey(value: unknown): string {
    return String(value || '').trim().toLowerCase();
  }

  private destinationCountry(destination: any): string | null {
    const nestedCountry = destination?.country && typeof destination.country === 'object'
      ? destination.country
      : null;
    const candidates = [
      destination?.country_name,
      destination?.countryName,
      typeof destination?.country === 'string' ? destination.country : null,
      nestedCountry?.name,
      nestedCountry?.country_name,
      destination?.country_code,
      destination?.countryCode
    ];

    for (const candidate of candidates) {
      if (typeof candidate !== 'string' || !candidate.trim()) {
        continue;
      }
      const value = candidate.trim();
      return COUNTRY_CODE_NAMES[value.toUpperCase()] || value;
    }
    return null;
  }

  get pickupControl() {
    return this.reactiveForm.get('pickup');
  }

  get dropoffControl() {
    return this.reactiveForm.get('dropoff');
  }

  get returnPickupControl() {
    return this.returnForm.get('pickupReturn');
  }

  get returnDropoffControl() {
    return this.returnForm.get('dropoffReturn');
  }
  
  

  private previousLocationValue: Record<string, string> = {};
  private justSelectedLocation: Record<string, boolean> = {};

  onLocationSelected(controlName: string): void {
    this.justSelectedLocation[controlName] = true;
  }

  onLocationFocus(form: UntypedFormGroup, controlName: string, event?: FocusEvent): void {
    if (this.justSelectedLocation[controlName]) {
      this.justSelectedLocation[controlName] = false;
      (event?.target as HTMLInputElement | undefined)?.select();
      return;
    }
    const control = form.get(controlName);
    const current = control?.value;
    if (control && current) {
      this.previousLocationValue[controlName] = current;
      control.setValue('');
    }
  }

  onLocationBlur(form: UntypedFormGroup, controlName: string): void {
    const control = form.get(controlName);
    if (control && !control.value && this.previousLocationValue[controlName]) {
      control.setValue(this.previousLocationValue[controlName]);
    }
    delete this.previousLocationValue[controlName];
  }

  selectEvent(item) {
    // do something with selected item
  }

  onChangeSearch(val: string) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }

  returnClicked =() =>{
    this.returning=true;
  }

  closeReturn(){
    this.returning=false;
  }





clickTopCity(depature,destination){
  var traveldate = formatDate(this.today,"yyyy-MM-dd","en-KE");
  let kisumu={
      'pickup' : depature,
      'dropoff' : destination,
      'pickupname' :depature,
      'dropoffname' : destination,
      'traveldate' : traveldate,
      'returndate': '',
      'returning' : this.returning
    }
    let p=Base64.encode(JSON.stringify(kisumu));
    this.dataService.changeMessage(p);
    this.router.navigate(['/booking', traveldate])
}

clickOffer(depature,destination,date){

  var traveldate = formatDate(date,"yyyy-MM-dd","en-KE");
  let kisumu={
      'pickup' : depature,
      'dropoff' : destination,
      'pickupname' :depature,
      'dropoffname' : destination,
      'traveldate' : traveldate,
      'returndate': '',
      'returning' : this.returning
    }

    let p=Base64.encode(JSON.stringify(kisumu));
    this.dataService.changeMessage(p);
    this.router.navigate(['/booking', traveldate])

}


  submitForm() {

    this.submitted = true;
    if (this.reactiveForm.invalid) {
      this.reactiveForm.markAllAsTouched();
      return;
    }
     let value = this.reactiveForm.value;
    var traveldate = formatDate(value.traveldate,"yyyy-MM-dd","en-KE");
    value.traveldate=traveldate;
    var returndate='';
    if(this.returning){
      var returndate = formatDate(value.returndate,"yyyy-MM-dd","en-KE");
       value.returndate=returndate;
    }
    this.formdata={
      'pickup' : value.pickup,
      'dropoff' : value.dropoff,
      'pickupname' : value.pickup,
      'dropoffname' : value.dropoff,
      'traveldate' : traveldate,
      'returndate': returndate,
      'returning' : this.returning
    }


    let p=Base64.encode(JSON.stringify(this.formdata));
    this.dataService.changeMessage(p);

    this.router.navigate(['/booking', traveldate])
  }

  submitReturnForm() {
    this.submittedReturn = true;
    if (this.returnForm.invalid) {
      this.returnForm.markAllAsTouched();
      return;
    }
     let value = this.returnForm.value;
    var traveldate = formatDate(value.traveldateReturn,"yyyy-MM-dd","en-KE");
    value.traveldateReturn=traveldate;
    var returndate = formatDate(value.returndate,"yyyy-MM-dd","en-KE");
    value.returndate=returndate;
    this.formdata={
      'pickup' : value.pickupReturn,
      'dropoff' : value.dropoffReturn,
      'pickupname' : value.pickupReturn,
      'dropoffname' : value.dropoffReturn,
      'traveldate' : traveldate,
      'returndate': returndate,
      'returning' : true
    }


    let p=Base64.encode(JSON.stringify(this.formdata));
    this.dataService.changeMessage(p);
    this.router.navigate(['/booking', traveldate])
  }

  private loadDestinations() {
    if (!isPlatformBrowser(this.platformId)) {
      this.data = [...this.defaultCities];
      this.destinationslists = [...this.defaultCities];
      this.optionsSubject.next([...this.defaultCities]);
      this.destinationLoading = false;
      return;
    }

    this.destinationLoading=true;

    this.service.getDestinations().subscribe(
      response => {
        let list: string[] = [];
        this.res = response;
          this.res.data.all_cities.forEach(element => {
              list.push(element.name);
              const country = this.destinationCountry(element);
              if (country) {
                this.cityCountries.set(this.cityKey(element.name), country);
              }
          });
        this.data=list;
        this.destinationslists=list;
        this.optionsSubject.next(list);
        let cities=Base64.encode(JSON.stringify(this.data));
        localStorage.setItem('mashpoa-cities', cities);
        this.destinationLoading=false;
      },
      error => {
        const cachedCities = localStorage.getItem('mashpoa-cities');
        if (cachedCities) {
          try {
            const cities = JSON.parse(Base64.decode(cachedCities));
            if (Array.isArray(cities)) {
              this.data = cities;
              this.destinationslists = cities;
              this.optionsSubject.next(cities);
            }
          } catch {
            // Ignore malformed legacy cache data and keep the form manually usable.
          }
        }
        this.destinationLoading=false;
      }
    );

  }

}
